import { api } from '../../config/api'
import {
  PLACE,
  POPULAR_PLACE,
  PLACE_DETAILS
} from '../../actions/actionTypes'

export const getPlace = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().place.list[lang].lastUpdate || !getState().place.list[lang].data.length) {
    dispatch({ type: PLACE.REQUEST, lang })
    return (
      fetch(api.place+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: PLACE.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: PLACE.FAILURE, error: err })
      })
    )
  }
}

export const getPoppularPlace = () => (dispatch, getState) => {
  const { lang, lasted } = getState()
  if (lasted !== getState().place.popular[lang].lastUpdate || !getState().place.popular[lang].data.length) {
    dispatch({ type: POPULAR_PLACE.REQUEST, lang })
    return (
      fetch(api.placePopular+'?language='+lang)
      .then(res => res.json())
      .then((res) => {
        dispatch({ type: POPULAR_PLACE.SUCCESS, data: res, lang, lasted })
      })
      .catch((err) => {
        dispatch({ type: POPULAR_PLACE.FAILURE, error: err })
      })
    )
  }
}

export const getPlaceDataById = (id) => (dispatch, getState) => {
  const { lang, lasted } = getState()
  dispatch({ type: PLACE_DETAILS.REQUEST, lang })
  return (
    fetch(api.place+'/'+id+'?language='+lang)
    .then(res => res.json())
    .then((res) => {
      dispatch({ type: PLACE_DETAILS.SUCCESS, data: res, lang, lasted })
    })
    .catch((err) => {
      dispatch({ type: PLACE_DETAILS.FAILURE, error: err })
    })
  )
}


// WEBPACK FOOTER //
// ./src/containers/Place/actions.js